import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from 'src/environments/environment';
import { User } from '../_models/user';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { confirmPasswordValidator } from '../validators/confirm-password.validator';

@Injectable({ providedIn: 'root' })
export class UserService {
  currentUserQuery$: any;
  currentUser: User = {};
  currentUser$: BehaviorSubject<User> = new BehaviorSubject<User>({});

  private currentUserSubject = new BehaviorSubject<User | null>(null);
  currentUsers$ = this.currentUserSubject.asObservable();

  private membersSubject = new BehaviorSubject<User[]>([]);
  public members$ = this.membersSubject.asObservable();

  constructor(private http: HttpClient, private fb: FormBuilder) {}

  updateUserForm = this.fb.group({
    first_name: ['', Validators.required],
    last_name: ['', Validators.required],
    email: ['', Validators.required],
    username: ['', Validators.required],
    role_id: [''],
    enabled: [true],
    webhook: [''],
    scope: [''],
  });

  updateMembers(users: User[]) {
    this.membersSubject.next(users);
  }

  getAll() {
    return this.http.get<User[]>(`${environment.apiUrl}/users`);
  }

  getById(id: number) {
    return this.http.get<User>(`${environment.apiUrl}/users/${id}`);
  }

  getUserById(id: number) {
    return this.http.get<User>(`${environment.apiUrl}/users/${id}`);
  }

  getMe() {
    return this.http.get<User>(`${environment.apiUrl}/users/me`);
  }

  loadCurrentUser() {
    this.getMe().subscribe((user) => {
      this.currentUser$.next(user);
    });
  }

  loadTheCurrentUser() {
    this.getMe().subscribe({
      next: (user) => {
        console.log('Loaded Current User:', user);
        
        this.currentUserSubject.next(user);

      },
      error: (err) => {
        console.error('Error loading current user:', err);
      },
    });

    return this.currentUser$;
  }

  getCurrentUser(): User {
    console.log('Current User from Service:', this.currentUserSubject.value);
    
    return this.currentUserSubject.value || {};
  }

  getCurrentLoggedInUser() {
    this.currentUserQuery$ = this.getMe().subscribe((user) => {
      this.currentUser = user;
      this.currentUser$.next(user);
    });

    return this.currentUser$;
  }

  clearCurrentLoggedInUser() {
    this.currentUser = {};
    this.currentUser$.next({});
  }

  postUser(user: any) {
    return this.http.post<any>(`${environment.apiUrl}/users/register`, user);
  }

  deleteUser(id: number) {
    return this.http.delete(`${environment.apiUrl}/users/${id}`);
  }

  forgotPassword(email: string) {
    return this.http.post(
      `${environment.apiUrl}/users/forgot-password`,
      {},
      {
        params: {
          email: email,
        },
      }
    );
  }

  resetPassword(email: string, token: string, password: string) {
    return this.http.post(
      `${environment.apiUrl}/users/reset-password`,
      { new_password: password },
      {
        params: {
          reset_token: token,
          email: email,
        },
      }
    );
  }

  updateUser(userId: number, userData: any) {
    const url = `${environment.apiUrl}/users/${userId}`;
    return this.http.put(url, userData);
  }

  getRoles() {
    return this.http.get(`${environment.apiUrl}/role`);
  }

  resetPasswordByAdmin(userId: number, newPassword: any) {
    return this.http.put(
      `${environment.apiUrl}/password/admin-reset/${userId}?new_password=${newPassword}`,
      newPassword
    );
  }
}
